import loginTemplate from './login/login.pug';
import forgotPWTemplate from './forgotpassword/forgotpassword.pug';
import setPWTemplate from './setpassword/setpassword.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider.state('login', {
    url: '/login',
    template: loginTemplate,
    controller: 'LoginController',
    controllerAs: 'vm'
  })
    .state('forgotpassword', {
      url: '/forgotpassword',
      template: forgotPWTemplate,
      controller: 'ForgotPasswordController',
      controllerAs: 'vm'
    })
    .state('setpassword', {
      url: '/setpassword',
      template: setPWTemplate,
      controller: 'SetPasswordController',
      controllerAs: 'vm'
    })
    .state('logout', {
      url: '/logout?referrer',
      referrer: 'main',
      template: '',
      controller: ['$state', 'AuthSvc', function($state, AuthSvc) {
        var referrer = $state.params.referrer || $state.current.referrer
        || 'main';
        AuthSvc.logout();
        $state.go(referrer);
      }]
    });
}];
